// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"433":"660190ee","442":"43fe8a0c","717":"bfdb1cde"}[chunkId] + ".chunk.js";
};